import * as React from 'react';
import { connect } from 'react-redux';
import { CAPTURE_CAR_DETAILS, PERSONAL_INSURANCE } from '../../../routes/routes';
import './TakePhotos.css';
import { handleNextStep, handleStepBack, showFnolTakePhoto, showPhotoError, submitFNOL, submitFNOLAndPhoto } from '../../../actions/claimSubmitActions';
import { navigateTo } from '../../../actions/navigationActions';
import { Image } from 'react-bootstrap';
import { setSelfInspectStep } from '../../../actions/profileActions';
import { showFNOLStepsScreen, showSelfInspectStepsScreen } from '../../../actions/fullscreenActions';

class TakePhotos extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.handleCaptureStep = this.handleCaptureStep.bind(this);
        this.getColClassName = this.getColClassName.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleLater = this.handleLater.bind(this);

        this.state = {
            coverToggle: false,
            selectedCover: false,

        }
    }

    async handleLater() {
        if (!this.props.ssp.drivableClaimsEnabled) {
            this.props.dispatchSubmitFNOL()
            this.props.dispatchHandleNextStep()
        } else {
            await this.props.dispatchHandleNextStep();
        }
    }

    getColClassName(name: string) {
        const prefix = "col" + " ";
        return prefix;
    }

    async handleSubmit() {
        var canSubmit = true;
        if (this.props.claimSubmit.claimDamagePhotoTypes) {
            for (var i = 0; i <= (this.props.claimSubmit.claimDamagePhotoTypes.length - 1); i++) {
                if (this.props.claimSubmit.claimDamagePhotoTypes[i].photoData === undefined || this.props.claimSubmit.claimDamagePhotoTypes.photoData === "") {
                    if (this.props.claimSubmit.claimDamagePhotoTypes[i].isSelected) {
                        canSubmit = false;
                    }
                }
            }
            if (canSubmit) {
                if (!this.props.ssp.drivableClaimsEnabled) {
                    await this.props.dispatchSubmitFNOLAndPhoto();
                    await this.props.dispatchHandleNextStep();
                } else {
                    await this.props.dispatchHandleNextStep();
                }
            }
            else {
                this.props.getShowPhotoError()
            }
        }
    }

    async handleCancel() {
        this.props.redirectTo(PERSONAL_INSURANCE)
    }

    async handleCaptureStep(step) {
        await this.props.dispatchSetFNOLStep(step);
        await this.props.dispatchShowFNOLStepsScreen();
    }

    public render() {

        let photosFront = <div></div>
        let photosFrontLeft = <div></div>
        let photosFrontRight = <div></div>
        let photosBack = <div></div>
        let photosBackLeft = <div></div>
        let photosBackRight = <div></div>
        let photosExtras = <div></div>
        let row = <div></div>


        if (this.props.claimSubmit.claimDamagePhotoTypes) {
            if (this.props.claimSubmit.damageListCar.damageFront) {
                photosFront = this.props.claimSubmit.claimDamagePhotoTypes.filter(item => item.isSelected === true && item.location === "front").map((photoItem, index) => {
                    if (photoItem.photoData !== "") {
                        return <div className="col" onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main photo-image-block-right" : "capture-images-block-main photo-image-block-left"}>
                                <Image src={photoItem.photoData} alt={photoItem.description} />
                                <div className="capture-images-block-inner-container-overlay" title={photoItem.description}>
                                    <div className="capture-images-block-icon"></div>
                                    <span className={"capture-images-block-icon-description " + photoItem.imageName + "-label"}>{photoItem.description}</span>
                                    <div className="capture-images-block-success-icon"></div>
                                </div>
                            </div>
                        </div>
                    } else {
                        return <div className="col" onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main capture-image-block-right" : "capture-images-block-main capture-image-block-left"}>
                                <div className="capture-images-block-inner-container">
                                    <div className={photoItem.imageName + " mt-3"} ></div>
                                    <span className="capture-images-block-icon-description">{photoItem.description}</span>
                                </div>
                            </div>
                        </div>
                    }
                });
            }
            if (this.props.claimSubmit.damageListCar.damageFrontLeft) {
                photosFrontLeft = this.props.claimSubmit.claimDamagePhotoTypes.filter(item => item.isSelected === true && item.location === "frontLeft").map((photoItem, index) => {
                    if (photoItem.photoData !== "") {
                        return <div className={this.getColClassName(photoItem.description.toLowerCase())} onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main photo-image-block-right" : "capture-images-block-main photo-image-block-left"}>
                                <Image src={photoItem.photoData} alt={photoItem.description} />
                                <div className="capture-images-block-inner-container-overlay" title={photoItem.description}>
                                    <div className="capture-images-block-icon"></div>
                                    <span className={"capture-images-block-icon-description " + photoItem.imageName + "-label"}>{photoItem.description}</span>
                                    <div className="capture-images-block-success-icon"></div>
                                </div>
                            </div>
                        </div>
                    } else {
                        return <div className="col" onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main capture-image-block-right" : "capture-images-block-main capture-image-block-left"}>
                                <div className="capture-images-block-inner-container">
                                    <div className={photoItem.imageName + " mt-3"}></div>
                                    <span className="capture-images-block-icon-description">{photoItem.description}</span>
                                </div>
                            </div>
                        </div>
                    }
                });
            }
            if (this.props.claimSubmit.damageListCar.damageFrontRight) {
                photosFrontRight = this.props.claimSubmit.claimDamagePhotoTypes.filter(item => item.isSelected === true && item.location === "frontRight").map((photoItem, index) => {
                    if (photoItem.photoData !== "") {
                        return <div className={this.getColClassName(photoItem.description.toLowerCase())} onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main photo-image-block-right" : "capture-images-block-main photo-image-block-left"}>
                                <Image src={photoItem.photoData} alt={photoItem.description} />
                                <div className="capture-images-block-inner-container-overlay" title={photoItem.description}>
                                    <div className="capture-images-block-icon"></div>
                                    <span className={"capture-images-block-icon-description " + photoItem.imageName + "-label"}>{photoItem.description}</span>
                                    <div className="capture-images-block-success-icon"></div>
                                </div>
                            </div>
                        </div>
                    } else {
                        return <div className="col" onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main capture-image-block-right" : "capture-images-block-main capture-image-block-left"}>
                                <div className="capture-images-block-inner-container">
                                    <div className={photoItem.imageName + " mt-3"}></div>
                                    <span className="capture-images-block-icon-description">{photoItem.description}</span>
                                </div>
                            </div>
                        </div>
                    }
                });
            }
            if (this.props.claimSubmit.damageListCar.damageBackLeft) {
                photosBackLeft = this.props.claimSubmit.claimDamagePhotoTypes.filter(item => item.isSelected === true && item.location === "backLeft").map((photoItem, index) => {
                    if (photoItem.photoData !== "") {
                        return <div className={this.getColClassName(photoItem.description.toLowerCase())} onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main photo-image-block-right" : "capture-images-block-main photo-image-block-left"}>
                                <Image src={photoItem.photoData} alt={photoItem.description} />
                                <div className="capture-images-block-inner-container-overlay" title={photoItem.description}>
                                    <div className="capture-images-block-icon"></div>
                                    <span className={"capture-images-block-icon-description " + photoItem.imageName + "-label"}>{photoItem.description}</span>
                                    <div className="capture-images-block-success-icon"></div>
                                </div>
                            </div>
                        </div>
                    } else {
                        return <div className="col" onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main capture-image-block-right" : "capture-images-block-main capture-image-block-left"}>
                                <div className="capture-images-block-inner-container">
                                    <div className={photoItem.imageName + " mt-3"}></div>
                                    <span className="capture-images-block-icon-description">{photoItem.description}</span>
                                </div>
                            </div>
                        </div>
                    }
                });
            }
            if (this.props.claimSubmit.damageListCar.damageBackRight) {
                photosBackRight = this.props.claimSubmit.claimDamagePhotoTypes.filter(item => item.isSelected === true && item.location === "backRight").map((photoItem, index) => {
                    if (photoItem.photoData !== "") {
                        return <div className={this.getColClassName(photoItem.description.toLowerCase())} onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main photo-image-block-right" : "capture-images-block-main photo-image-block-left"}>
                                <Image src={photoItem.photoData} alt={photoItem.description} />
                                <div className="capture-images-block-inner-container-overlay" title={photoItem.description}>
                                    <div className="capture-images-block-icon"></div>
                                    <span className={"capture-images-block-icon-description " + photoItem.imageName + "-label"}>{photoItem.description}</span>
                                    <div className="capture-images-block-success-icon"></div>
                                </div>
                            </div>
                        </div>
                    } else {
                        return <div className="col" onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main capture-image-block-right" : "capture-images-block-main capture-image-block-left"}>
                                <div className="capture-images-block-inner-container">
                                    <div className={photoItem.imageName + " mt-3"}></div>
                                    <span className="capture-images-block-icon-description">{photoItem.description}</span>
                                </div>
                            </div>
                        </div>
                    }
                });
            }
            if (this.props.claimSubmit.damageListCar.damageBack) {
                photosBack = this.props.claimSubmit.claimDamagePhotoTypes.filter(item => item.isSelected === true && item.location === "back").map((photoItem, index) => {
                    if (photoItem.photoData !== "") {
                        return <div className={this.getColClassName(photoItem.description.toLowerCase())} onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main photo-image-block-right" : "capture-images-block-main photo-image-block-left"}>
                                <Image src={photoItem.photoData} alt={photoItem.description} />
                                <div className="capture-images-block-inner-container-overlay" title={photoItem.description}>
                                    <div className="capture-images-block-icon"></div>
                                    <span className={"capture-images-block-icon-description " + photoItem.imageName + "-label"}>{photoItem.description}</span>
                                    <div className="capture-images-block-success-icon"></div>
                                </div>
                            </div>
                        </div>
                    } else {
                        return <div className="col" onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main capture-image-block-right" : "capture-images-block-main capture-image-block-left"}>
                                <div className="capture-images-block-inner-container">
                                    <div className={photoItem.imageName + " mt-3"}></div>
                                    <span className="capture-images-block-icon-description">{photoItem.description}</span>
                                </div>
                            </div>
                        </div>
                    }
                });
            }
            if (this.props.claimSubmit.damageListCar.damageBack) {
                photosBackLeft = this.props.claimSubmit.claimDamagePhotoTypes.filter(item => item.isSelected === true && item.location === "backLeft").map((photoItem, index) => {
                    if (photoItem.photoData !== "") {
                        return <div className={this.getColClassName(photoItem.description.toLowerCase())} onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main photo-image-block-right" : "capture-images-block-main photo-image-block-left"}>
                                <Image src={photoItem.photoData} alt={photoItem.description} />
                                <div className="capture-images-block-inner-container-overlay" title={photoItem.description}>
                                    <div className="capture-images-block-icon"></div>
                                    <span className={"capture-images-block-icon-description " + photoItem.imageName + "-label"}>{photoItem.description}</span>
                                    <div className="capture-images-block-success-icon"></div>
                                </div>
                            </div>
                        </div>
                    } else {
                        return <div className="col" onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main capture-image-block-right" : "capture-images-block-main capture-image-block-left"}>
                                <div className="capture-images-block-inner-container">
                                    <div className={photoItem.imageName + " mt-3"}></div>
                                    <span className="capture-images-block-icon-description">{photoItem.description}</span>
                                </div>
                            </div>
                        </div>
                    }
                });
            }
            if (this.props.claimSubmit.damageListCar.damageExtras) {
                photosExtras = this.props.claimSubmit.claimDamagePhotoTypes.filter(item => item.isSelected === true && item.location === "special").map((photoItem, index) => {
                    if (photoItem.photoData !== "") {
                        return <div className={this.getColClassName(photoItem.description.toLowerCase())} onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main photo-image-block-right" : "capture-images-block-main photo-image-block-left"}>
                                <Image src={photoItem.photoData} alt={photoItem.description} />
                                <div className="capture-images-block-inner-container-overlay" title={photoItem.description}>
                                    <div className="capture-images-block-icon"></div>
                                    <span className={"capture-images-block-icon-description " + photoItem.imageName + "-label"}>{photoItem.description}</span>
                                    <div className="capture-images-block-success-icon"></div>
                                </div>
                            </div>
                        </div>
                    } else {
                        return <div className="col" onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main capture-image-block-right" : "capture-images-block-main capture-image-block-left"}>
                                <div className="capture-images-block-inner-container">
                                    <div className="special mt-3"></div>
                                    <span className="capture-images-block-icon-description">{photoItem.description}</span>
                                </div>
                            </div>
                        </div>
                    }
                });
            }


        }
        return (
            <>
                <div id="FNOLCaptureImagesLanding" className="container-fluid">
                    {this.props.claimSubmit.damageListCar.damageFront &&
                        <div className="text-center">
                            <h3>Front</h3>
                            <div className="row new-page-main-row">
                                <div className="row captureimages-images-block">
                                    {photosFront}
                                </div>
                            </div>
                        </div>
                    }
                    {this.props.claimSubmit.damageListCar.damageFrontLeft &&
                        <div className="text-center">
                            <h3>Front left</h3>
                            <div className="row new-page-main-row">
                                <div className="row captureimages-images-block">
                                    {photosFrontLeft}
                                </div>
                            </div>
                        </div>
                    }
                    {this.props.claimSubmit.damageListCar.damageFrontRight &&
                        <div className="text-center">
                            <h3>Front right</h3>
                            <div className="row new-page-main-row">
                                <div className="row captureimages-images-block">
                                    {photosFrontRight}
                                </div>
                            </div>
                        </div>
                    }
                    {this.props.claimSubmit.damageListCar.damageBack &&
                        <div className="text-center">
                            <h3>Back</h3>
                            <div className="row new-page-main-row">
                                <div className="row captureimages-images-block">
                                    {photosBack}
                                </div>
                            </div>
                        </div>
                    }
                    {this.props.claimSubmit.damageListCar.damageBackLeft &&
                        <div className="text-center">
                            <h3>Back left</h3>
                            <div className="row new-page-main-row">
                                <div className="row captureimages-images-block">
                                    {photosBackLeft}
                                </div>
                            </div>
                        </div>
                    }
                    {this.props.claimSubmit.damageListCar.damageBackRight &&
                        <div className="text-center">
                            <h3>Back right</h3>
                            <div className="row new-page-main-row">
                                <div className="row captureimages-images-block">
                                    {photosBackRight}
                                </div>
                            </div>
                        </div>
                    }
                    {this.props.claimSubmit.damageListCar.damageExtras &&
                        <div className="text-center">
                            <h3>Extras</h3>
                            <div className="row new-page-main-row">
                                <div className="row captureimages-images-block">
                                    {photosExtras}
                                </div>
                            </div>
                        </div>
                    }

                    <button className="btn btn-solid-red  mt-4 col-12" onClick={this.handleSubmit}>Next</button>
                    <button className="btn btn-outline-red mr-2 col-12 mb-3 mt-3 w-100" onClick={this.props.dispatchHandleStepBack}>Back</button>
                    <div className="text-center cursor mb-3">
                        <span className="red-text" onClick={this.handleLater}><b>Come back later</b></span>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        selfInspect: state.selfInspect,
        claimSubmit: state.claimSubmit,
        ssp: state.ssp
    }
}
const mapDispatchToProps = (dispatch: any) => {
    return {
        //getFNOLPhotos: () => dispatch(getFNOLPhotos()),
        //getShowPhotoError: () => dispatch(showPhotoError()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchHandleStepBack: () => dispatch(handleStepBack()),
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        dispatchSetFNOLStep: (data) => dispatch(showFnolTakePhoto(data)),
        dispatchShowFNOLStepsScreen: () => dispatch(showFNOLStepsScreen()),
        getShowPhotoError: () => dispatch(showPhotoError()),
        dispatchSubmitFNOLAndPhoto: () => dispatch(submitFNOLAndPhoto()),
        dispatchSubmitFNOL: () => dispatch(submitFNOL()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TakePhotos);